import { Model } from "@vuex-orm/core"
import User from "./User"

export default class Dan extends Model {
  static entity = "dans"

  static fields() {
    return {
      id: this.string(""),
      dan: this.number(0),
      danclass: this.string(""),
      dantext: this.string(""),
      hierarchy: this.attr([]),
      data: this.attr([])
    }
  }

  id!: string
  dan!: number
  danclass!: string
  dantext!: string
  hierarchy!: string[]
  data!: User[]
}
